// A tab left open across a deploy still runs the old bundle, whose lazily loaded files no longer exist on the
// server, so opening part of the app that needs one fails. Vite reports this as vite:preloadError: reload to pick
// up the current build instead. If the reloaded page fails too, the files are unreachable for some other reason, so
// let the error through to be reported rather than reloading in a loop. Without session storage there's no way to
// tell, so don't reload at all.
// Preventing the error makes Vite resolve the failed import to undefined, so importers have to allow for that.
const LAST_RELOAD_KEY = 'stale_bundle_last_reload';
const MIN_MILLISECONDS_BETWEEN_RELOADS = 60 * 1000;

// Kept in memory, so the reloaded document starts without it
let reloadRequested = false;

const onPreloadError = (event) => {
  // Once this page has asked to reload, any other file it fails to load on its way out needs no reporting either
  if (reloadRequested) {
    event.preventDefault();
    return;
  }

  try {
    const lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY));
    if (Date.now() - lastReload < MIN_MILLISECONDS_BETWEEN_RELOADS) return;
    sessionStorage.setItem(LAST_RELOAD_KEY, Date.now());
  } catch {
    return;
  }

  reloadRequested = true;
  event.preventDefault();
  window.location.reload();
};

const setup = () => {
  window.addEventListener('vite:preloadError', onPreloadError);
  return () => window.removeEventListener('vite:preloadError', onPreloadError);
};

export { setup };
